import { createTheme } from '@mui/material/styles';
import { red, yellow, green } from '@mui/material/colors';
//import "fontsource-nunito-sans";

export const drawerWidth = 240;

export default createTheme({
  typography: {
    fontFamily: ['Open Sans', 'Nunito Sans', 'Roboto', 'Arial'].join(','),
  },
  palette: {
    primary: {
      main: '#0073a3',
    },
    secondary: {
      main: '#90a445',
    },
    negative: {
      main: '#e91e42',
    },
  },
  custom: {
    sideBarTextColor: '#cecece',
    white: '#ffffff',
    positive: '#90a445',
    neutral: '#ffcc80',
    negative: '#e91e42',
    chartNeutral: '#e0e0e0',
    gray: 'rgba(0, 0, 0, 0.65)',
    inactive: '#bbbbbb',
  },
  portfolio: {
    positive: '#90a445',
    neutral: '#ffcc80',
    negative: '#e91e42',
    inactive: '#efefef',
  },
  kpi: {
    positive: green[50],
    neutral: yellow[50],
    negative: red[50],
    inactive: 'rgba(0,0,0,.1)',
  },
  status: {
    danger: red,
  },
  overrides: {
    MuiDrawer: {
      root: {
        width: drawerWidth,
        flexShrink: 0,
      },
      paper: {
        width: drawerWidth,
        backgroundColor: '#45474e',
      },
    },
    MuiAccordion: {
      root: {
        borderRadius: 'unset',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#ccc',
        boxShadow: 'none',
        '&$expanded': {
          margin: 'auto',
          borderRadius: 'unset',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: '#ccc',
          boxShadow: 'none',
        },
      },
      rounded: {
        borderRadius: 'unset',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#ccc',
        boxShadow: 'none',
        '&$expanded': {
          margin: 'auto',
          borderRadius: 'unset',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: '#ccc',
          boxShadow: 'none',
        },
        '&:first-child&:last-child': {
          borderRadius: 'unset',
        },
      },
      expanded: {},
    },
    MuiAccordionDetails: {
      root: {
        padding: '0 4px',
      },
    },
    MuiAccordionSummary: {
      root: {
        minHeight: 24,
        '&$expanded': {
          minHeight: 24,
        },
      },
      content: {
        margin: 'auto',
        '&$expanded': {
          margin: 'auto',
        },
      },
      expanded: {},
    },
    MuiIconButton: {
      root: {
        padding: 4,
      },
    },
    MuiChip: {
      root: {
        fontSize: '0.75rem',
      },
    },
    MuiPaper: {
      elevation1: {
        borderRadius: 'unset',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#ccc',
        boxShadow: 'none',
      },
      elevation2: {
        borderRadius: 'unset',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#ccc',
        boxShadow: 'none',
      },
    },
    MuiLinearProgress: {
      root: {
        backgroundColor: '#0091ae',
      },
      barColorPrimary: {
        backgroundColor: '#0091ae',
      },
      colorPrimary: {
        backgroundColor: '#00bda5',
      },
      indeterminate: {
        backgroundColor: '#00bda5',
      },
    },
    MuiButton: {
      root: {
        span: {
          textTransform: 'none',
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        color: '#595959 !important',
        backgroundColor: 'white !important',
        padding: '5px 10px !important',
        fontSize: '12px !important',
      },
      arrow: {
        color: 'white !important',
      },
    },
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: '#595959',
          backgroundColor: '#ffffff',
          fontSize: '12px',
          // padding: '0px !important',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        },
        arrow: {
          color: '#ffffff',
        },
      },
    },
  },
  props: {
    MuiButton: {
      color: 'primary',
      variant: 'contained',
    },
    MuiDrawer: {
      variant: 'permanent',
      anchor: 'left',
    },
    MuiTextField: {
      variant: 'outlined',
      margin: 'dense',
    },
    MuiSelect: {
      variant: 'outlined',
      margin: 'dense',
    },
    MuiInputLabel: {
      variant: 'outlined',
    },
  },
});
